//import $ from 'jquery';

import { View } from 'backbone';
import { Model } from 'backbone';
import template  from 'dashboard/reports/modal/report-delete-modal.ejs';
import ConfirmReportDeleteModal from 'dashboard/reports/modal/ConfirmReportDeleteModal.js';
import NotificationService from 'NotificationService.js';
import listService      from 'ListService.js';

class ReportDeleteModal extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#deleteModal";

        return this;
    }

    activateFields() {
        // Activate delete previous version option
        if (this.model.get('versionList') instanceof Array ){
            $('#deletePreviousPanel').removeClass('disabledPanel');
        } else if (this.model.get('versionList')['@MajorVersion'] !== '0'
                    && this.model.get('versionList')['@MajorVersion'] !== 0 ) {
            $('#deletePreviousPanel').removeClass('disabledPanel');
        }
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set(propName, propVal);
        $('button.btn-select-field').button({disabled: false});
    }

    confirmDelete(){
        var confirmReportDeleteModal = new ConfirmReportDeleteModal({model: new Model({reportName: this.model.get('reportName'),
            reportId: this.model.get('reportId'), reportLink: this.model.get('reportLink'),
            versionList: this.model.get('versionList'), mode: this.model.get('toDelete'),
            groupId: this.model.get('groupId'), groupType: this.model.get('groupType'),parentId: this.model.get('parentId')
        })});
        confirmReportDeleteModal.render().then((result)=>{
            listService.reportItemSelected = undefined;
            return(result);
        }, rejectReason => { 
            //this is to receive the rejection from the main window, 
            //no action required.
        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
            return(error);
        });
    }

    bindEvents() {
        $('input[type=radio][name=toDelete]').change((e)=>{
            this.updateRadioAttributes(e);
        });
    }

    unbindEvents() {
        $('input[type=radio][name=toDelete]').unbind();
    }

    closeModal() {
        $(this.El).remove();
    }

    render() {
        let container = $('#deleteModal');
        if (container) {
            container.remove();
        }

        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            var self = this;

            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: "auto",
                width: 450,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-field',
                        'disabled': true,
                        click: () => {
                            self.unbindEvents();
                            this.dialog.dialog( "close" );
                            resolve(self.confirmDelete());
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.dialog.dialog("close");
                            this.closeModal();
                            reject();
                        }
                    }
                ],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () =>{
                    self.bindEvents();
                    self.activateFields();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
            this.delegateEvents();
            return this;
        });
    }

}

export default ReportDeleteModal;
